module.exports = __webpack_public_path__ + "static/img/13.77bb74c.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/4/4/zh/13.png
// module id = pDi+
// module chunks = 0